module.exports = __webpack_public_path__ + "img/im.da22f56e.svg";